import { TextField, TextFieldProps } from '@mui/material';
import { DateTimePicker, TimePicker } from '@mui/x-date-pickers';
import { FC } from 'react';
import {
  Autocomplete,
  CheckBox,
  CheckBoxProps,
  InputWithSelect,
  IntegerTextField,
  RadioGroup,
  RadioGroupProps,
  SelectBox,
  Slider,
  Switch,
  TabsField,
} from '../components';
import { InputWithSelectProps } from '../components/input/InputWithSelect.types';
import {
  withFormikAutocomplete,
  withFormikDateTimePicker,
  withFormikInput,
  withFormikRadio,
  withFormikSelectBox,
  withFormikSlider,
  withFormikSwitch,
  withFormikTabs,
  withFormikTimePicker,
} from './withFormik';

export const TextFieldFormik = withFormikInput<TextFieldProps>(TextField);
export const CheckBoxFormik = withFormikInput<CheckBoxProps>(CheckBox as FC<CheckBoxProps>);
export const SelectBoxFormik = withFormikSelectBox(SelectBox);
export const SwitchFormik = withFormikSwitch(Switch);
export const RadioGroupFormik = withFormikRadio<RadioGroupProps>(RadioGroup);
export const TabsFormik = withFormikTabs(TabsField);
export const SliderFormik = withFormikSlider(Slider);
export const InputWithSelectFormik = withFormikInput<InputWithSelectProps>(InputWithSelect);
export const TimePickerFormik = withFormikTimePicker(TimePicker);
export const IntegerTextFieldFormik = withFormikInput<TextFieldProps>(IntegerTextField);
export const DateTimePickerFormik = withFormikDateTimePicker(DateTimePicker);
export const AutocompleteFormik = withFormikAutocomplete(Autocomplete);
